"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _ActivityIndicator = _interopRequireDefault(require("../../../ui/ActivityIndicator"));

var _Tooltip = _interopRequireDefault(require("../Tooltip"));

var _LayerControlsView = _interopRequireDefault(require("../../views/LayerControlsView"));

var _utils = require("../../../utils");

var _View = _interopRequireDefault(require("../View"));

var _DOM = _interopRequireDefault(require("../../../display/DOM"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __extends = void 0 && (void 0).__extends || function () {
  var extendStatics = function (d, b) {
    extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    };

    return extendStatics(d, b);
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

// store a reference to the active popover so it can be dismissed when a new one is presented
var activePopover = null;

var ButtonControls =
/** @class */
function (_super) {
  __extends(ButtonControls, _super);

  function ButtonControls(opts) {
    var _this = _super.call(this, (0, _utils.extend)({
      controls: [{
        close: true,
        activity: false,
        settings: undefined
      }]
    }, opts, {
      ui: {
        close: '.awxjs__ui-btn-close',
        settings: '.awxjs__ui-btn-settings',
        controls: '.awxjs__ui-btn-controls'
      }
    })) || this;

    _this._handleWindowClick = function (e) {
      var $target = (0, _DOM.default)(e.target);
      var $view = _this._popover.$el;

      if ($view !== $target && $view.contains($target) === false) {
        _this._hidePopover();

        window.removeEventListener('click', _this._handleWindowClick);
      }
    };

    var controls = _this.opts.controls;

    if (controls.activity) {
      _this._indicator = new _ActivityIndicator.default({
        size: 24,
        strokeWidth: 2
      });
    }

    return _this;
  }

  ButtonControls.prototype.setLoading = function (loading) {
    if (this._indicator) {
      if (loading) {
        this._indicator.startAnimating();
      } else {
        this._indicator.stopAnimating();
      }
    }

    this.ui.close.css('opacity', loading ? 0 : 1);

    if (this.ui.settings) {
      this.ui.settings.css('opacity', loading ? 0 : 1);
    }
  };

  ButtonControls.prototype.addToButton = function (button) {
    var _this = this;

    if (button.ui.target) {
      this.remove();
      this.addTo(button.$el);
      button.on('select', function () {
        if (_this.ui.settings) {
          _this.ui.settings.show();
        }
      }).on('deselect', function () {
        if (_this.ui.close) {
          _this.ui.close.css('opacity', 0);
        }

        if (_this.ui.settings) {
          _this.ui.settings.hide();
        }

        if (_this._popover) {
          _this._hidePopover();
        }
      });
    }
  };

  ButtonControls.prototype._render = function () {
    var controls = this.opts.controls;
    var result = '';

    if (controls.close) {
      result += "\n\t\t\t\t<div class=\"awxjs__ui-btn-action awxjs__ui-btn-close\" title=\"Close\">\n\t\t\t\t\t<svg width=\"100pt\" height=\"100pt\" version=\"1.1\" viewBox=\"0 0 100 100\" xmlns=\"http://www.w3.org/2000/svg\">\n\t\t\t\t\t\t<path d=\"m22.699 77.301c0.80078 0.80078 1.8008 1.1992 2.8008 1.1992s2-0.39844 2.8008-1.1992l21.699-21.602 21.699 21.699c0.80078 0.80078 1.8008 1.1992 2.8008 1.1992s2-0.39844 2.8008-1.1992c1.6016-1.6016 1.6016-4.1016 0-5.6992l-21.602-21.699 21.699-21.699c1.6016-1.6016 1.6016-4.1016 0-5.6992-1.6016-1.6016-4.1016-1.6016-5.6992 0l-21.699 21.699-21.699-21.602c-1.6016-1.6016-4.1016-1.6016-5.6992 0-1.6016 1.6016-1.6016 4.1016 0 5.6992l21.699 21.602-21.602 21.699c-1.5977 1.5-1.5977 4.1016 0 5.6016z\"/>\n\t\t\t\t\t</svg>\n\t\t\t\t</div>\n\t\t\t";
    }

    if (controls.settings) {
      result += "\n\t\t\t\t<div class=\"awxjs__ui-btn-action awxjs__ui-btn-settings\" title=\"Settings\">\n\t\t\t\t\t<svg version=\"1.1\" viewBox=\"0 0 100 100\" xmlns=\"http://www.w3.org/2000/svg\">\n\t\t\t\t\t\t<path d=\"m94.801 40.801-10.602-1.8008c-0.60156-1.8984-1.3984-3.6992-2.3008-5.5l6.1992-8.6992c0.89844-1.3008 0.80078-3.1016-0.30078-4.1992l-8.5-8.5c-1.1016-1.1016-2.8984-1.3008-4.1992-0.30078l-8.6992 6.1992c-1.6992-0.89844-3.6016-1.6992-5.5-2.3008l-1.6992-10.5c-0.30078-1.6016-1.6016-2.6992-3.1992-2.6992h-12c-1.6016 0-2.8984 1.1016-3.1992 2.6992l-1.8008 10.602c-1.8984 0.60156-3.6992 1.3984-5.5 2.3008l-8.6992-6.1992c-1.3008-0.89844-3.1016-0.80078-4.1992 0.30078l-8.5 8.5c-1.1016 1.1016-1.3008 2.8984-0.30078 4.1992l6.1992 8.6992c-0.89844 1.6992-1.6992 3.6016-2.3008 5.5l-10.5 1.6992c-1.6016 0.30078-2.6992 1.6016-2.6992 3.1992v12c0 1.6016 1.1016 2.8984 2.6992 3.1992l10.602 1.8008c0.60156 1.8984 1.3984 3.6992 2.3008 5.5l-6.1992 8.6992c-0.89844 1.3008-0.80078 3.1016 0.30078 4.1992l8.5 8.5c1.1016 1.1016 2.8984 1.3008 4.1992 0.30078l8.6992-6.1992c1.6992 0.89844 3.6016 1.6992 5.5 2.3008l1.8008 10.602c0.30078 1.6016 1.6016 2.6992 3.1992 2.6992h12c1.6016 0 2.8984-1.1016 3.1992-2.6992l1.6992-10.703c1.8984-0.60156 3.6992-1.3984 5.5-2.3008l8.6992 6.1992c1.3008 0.89844 3.1016 0.80078 4.1992-0.30078l8.5-8.5c1.1016-1.1016 1.3008-2.8984 0.30078-4.1992l-6.1992-8.6992c0.89844-1.6992 1.6992-3.6016 2.3008-5.5l10.602-1.8008c1.6016-0.30078 2.6992-1.6016 2.6992-3.1992v-11.898c-0.10156-1.6016-1.2031-2.8984-2.8008-3.1992zm-44.801 26.301c-9.5 0-17.102-7.6992-17.102-17.102 0-9.5 7.6992-17.102 17.102-17.102 9.3984 0 17.102 7.6016 17.102 17.102s-7.6016 17.102-17.102 17.102z\"/>\n\t\t\t\t\t</svg>\n\t\t\t\t</div>\n\t\t\t";
    }

    if (result !== '') {
      result = "<div class=\"awxjs__ui-btn-controls\">" + result + "</div>";
    }

    return result;
  };

  ButtonControls.prototype._setupEvents = function () {
    var _this = this;

    _super.prototype._setupEvents.call(this);

    var controls = this.opts.controls;

    if (this._indicator) {
      this._indicator.appendTo(this.$el);
    }

    if (controls.settings && this.ui.settings) {
      this.ui.settings.on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        if (!_this._popover) {
          var view = new _LayerControlsView.default({
            controls: controls.settings
          });
          view.on('change', function (ee) {
            _this.trigger('change', __assign({}, ee.data));
          });
          var tooltip = new _Tooltip.default(view.$el, {
            place: 'left',
            className: 'awxjs__ui-layer-controls-popover',
            showClose: true
          });
          view.addTo(tooltip.$el);
          tooltip.attachTo(_this.parent());
          tooltip.setContent(view.$el);
          _this._popover = tooltip;
          _this._controls = view;
        }

        if (_this._popover.visible) {
          _this._hidePopover();
        } else {
          _this._showPopover();
        }

        window.addEventListener('click', _this._handleWindowClick);
      });
    }
  };

  ButtonControls.prototype._showPopover = function () {
    if (activePopover) {
      activePopover.hide();
    }

    this._popover.show();

    activePopover = this._popover;
  };

  ButtonControls.prototype._hidePopover = function () {
    this._popover.hide();

    activePopover = null;
  };

  return ButtonControls;
}(_View.default);

var _default = ButtonControls;
exports.default = _default;
module.exports = exports.default;